/** @file Allocates a Sample sized for a skeleton. */
import { channelOffsets, type Sample } from '../contracts/sample';
import { deformSize } from '../pose/deformSize';
import type { SkeletonData } from '../skeletonData';

/** Allocates a Sample with every channel unmasked; deform[i] is sized deformSize(attachment i), like Pose.deform. */
export function createSample(data: SkeletonData): Sample {
  const end = channelOffsets(data).end;
  let maxEvents = 0;
  for (const anim of data.animations) {
    for (const tl of anim.timelines) if (tl.k === 'event') maxEvents = Math.max(maxEvents, tl.times.length);
  }
  return {
    values: new Float64Array(end),
    mask: new Uint8Array(end),
    inherit: new Int8Array(data.bones.length).fill(-1),
    attachments: new Int32Array(data.slots.length).fill(-2),
    drawOrder: Int32Array.from(data.slots, (_, i) => i),
    drawOrderKeyed: false,
    deform: data.attachments.map((a) => new Float64Array(deformSize(a))),
    deformKeyed: new Uint8Array(data.attachments.length),
    events: new Int32Array(maxEvents),
    eventCount: 0,
  };
}
